import src from "IMAGE";
export default { src, width: 324, height: 98, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AFFIF31HLQxaAAUFHwAGBiUABgYlAAQEGgAGBiYABgYmAIRsIsFsRhOLAgUFHAAGBiUABQYiAAUFHgAGBiYABgYlEmwHTVWkwv4AAAAASUVORK5CYII="};
